export enum RequestTabs {
	// BasicInformation,
  // OpnConsents,
  Introduction,
	OpnOfferEvaluationMethods,
	// OpnOfferEvaluationMembers,
  // OpnBoardMembersList,
  // OpnSuppliersList,
  RequirementList,
  OpnCommercialLegalTerm,
  OpnProjectdeadlinesList,
  Documents,
	Communication
}
